import React from "react";
import LegalPage from "./LegalPage";

export default function CookiePolicy() {
  return (
    <LegalPage
      path="/cookie-policy"
      heading="Cookie Policy"
      updated="September 2026"
      title="Cookie Policy | Registry Feed"
      description="How Registry Feed uses cookies and similar technologies on its website and dashboard."
    >
      <p>This Cookie Policy explains how Registry Feed uses cookies and similar technologies on our website and dashboard.</p>
      <h2>What are cookies?</h2>
      <p>Cookies are small text files that a website stores in your browser. They help sites remember you and how you use them.</p>
      <h2>How we use cookies</h2>
      <ul>
        <li><strong>Strictly necessary cookies</strong> — required for the site to function (for example, keeping you logged into the dashboard). Turning these off will break the Service.</li>
        <li><strong>Preferences</strong> — remember your theme choice (light / dark) and other UI preferences.</li>
        <li><strong>Analytics</strong> — lightweight analytics (currently via PostHog) that help us understand how the site is used, so we can improve it. This does not include selling your personal information.</li>
      </ul>
      <h2>Third-party cookies</h2>
      <p>Some cookies are set by third-party services embedded in our site (for example, analytics providers or fonts). These are governed by the third parties' own privacy and cookie policies.</p>
      <h2>Your choices</h2>
      <p>You can control cookies from your browser settings. Blocking essential cookies will prevent you from logging into the dashboard.</p>
      <h2>Updates</h2>
      <p>We may update this Cookie Policy from time to time. When we do, we'll update the "Last updated" date above.</p>
    </LegalPage>
  );
}
